import { render, staticRenderFns } from "./coupanList.vue?vue&type=template&id=4399d37d&scoped=true"
import script from "./coupanList.vue?vue&type=script&lang=js"
export * from "./coupanList.vue?vue&type=script&lang=js"
import style0 from "./coupanList.vue?vue&type=style&index=0&id=4399d37d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4399d37d",
  null
  
)

export default component.exports